/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */
import { getApiUrl } from "../api";
import { useEffect, useState } from "react";
import { Link } from "./AppLink";

const stripHtml = (value) => String(value || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
const getPolicyDetailsPath = (policy) => `/foundation-policies/policy/${policy?.id || 0}`;

const mapFooterPolicy = (item, index, language = "en") => {

  return {
    id: item?.id || String(index + 1),
    title: stripHtml(language === "ar"
      ? item?.title_ar || item?.title || item?.title_en
      : item?.title_en || item?.title),
  };
};

export default function Footer({ language = "en" }) {
  const [policies, setPolicies] = useState([]);
  const isArabic = language === "ar";
  const text = isArabic ? {
    about: "عن المؤسسة", brief: "نبذة عن المؤسسة", directors: "مجلس الإدارة", structure: "الهيكل التنظيمي", foundationPolicies: "سياسات المؤسسة", complaints: "الشكاوى والمقترحات",
    donation: "التبرعات", quickDonation: "التبرع السريع", inKindDonation: "التبرعات العينية", projects: "مشاريعنا", criticalCases: "الحالات الحرجة",
    policy: "السياسات", viewAll: "عرض جميع السياسات", follow: "تابعنا على مواقع التواصل:", copyright: "© 2026 جميع الحقوق محفوظة.",
    facebook: "فيسبوك", youtube: "يوتيوب", instagram: "إنستغرام",
    description: "تأسست مؤسسة تراحم كجهة خيرية رسمية بعد اعتمادها من دائرة الشؤون الإسلامية والعمل الخيري بدبي بتاريخ 2 أغسطس 2012 (تصريح رقم 93)، وذلك انطلاقًا من مبادرة إنسانية أطلقها مجموعة من أبناء الوطن لخدمة المحتاجين.",
  } : {
    about: "About Foundation", brief: "Foundation's Brief", directors: "Board of Directors", structure: "Organization Structure", foundationPolicies: "Foundation's Policies", complaints: "Complaints & Suggestions",
    donation: "Donation", quickDonation: "Quick Donation", inKindDonation: "In Kind Donation", projects: "Our Projects", criticalCases: "Critical Cases",
    policy: "Policy", viewAll: "View All Policies", follow: "Follow Us On Socials:", copyright: "Copyright © 2026 All Rights Reserved.",
    facebook: "Facebook", youtube: "Youtube", instagram: "Instagram",
    description: "TARAHAM Foundation was established as an official charity Foundation after being officially approved by the Department of Islamic Affairs and Charitable Activities in Dubai on the 2nd of August 2012 (permit number 93) by a humanitarian initiative from a group of sons of the homeland to serve the needy.",
  };

  useEffect(() => {
    const controller = new AbortController();

    const loadPolicies = async () => {
      try {
        const response = await fetch(getApiUrl("/api/GetFoundationPoliciesList.ashx?page=1&pageSize=4"), {
          headers: { Accept: "application/json" },
          credentials: "include",
          signal: controller.signal,
        });

        if (!response.ok) throw new Error(`Footer policies request failed with ${response.status}`);

        const result = await response.json();
        const rows = Array.isArray(result?.data) ? result.data : [];
        const mappedPolicies = rows.map((item, index) => mapFooterPolicy(item, index, language)).filter((policy) => policy.title).slice(0, 4);

        if (mappedPolicies.length) {
          setPolicies(mappedPolicies);
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.warn("Unable to load footer policies", error);
        }
      }
    };

    loadPolicies();
    return () => controller.abort();
  }, [language]);

  return (
    <>
    <footer className="main-footer-gold bg-section dark-section">
      <div className="container">
        <div className="row">
          <div className="col-xl-4">
            <div className="about-footer-gold">
              <div className="footer-logo-gold">
                <img src="/images/img/Tarahum_logo.png" alt="" />
              </div>
              <div className="about-footer-content-gold">
                <p>
                  {text.description}
                </p>
              </div>
              <div className="iso-wrap">
                <a href="#">
                  <img src="/images/img/ISO37000.png" alt="" />
                </a>
                <a href="#">
                  <img src="/images/img/ISO9001.png" alt="" />
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            <div className="footer-links-box-gold">
              <div className="footer-links-gold">
                <h2>
                  {text.about}
                </h2>
                <ul>
                  <li>
                    <Link to="/about-us">
                      {text.brief}
                    </Link>
                  </li>
                  <li>
                    <Link to="/directors">
                      {text.directors}
                    </Link>
                  </li>
                  <li>
                    <Link to="/organization-structure">
                      {text.structure}
                    </Link>
                  </li>
                  <li>
                    <Link to="/foundation-policies">
                      {text.foundationPolicies}
                    </Link>
                  </li>
                  <li>
                    <Link to="/complaint">
                      {text.complaints}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer-links-gold">
                <h2>
                  {text.donation}
                </h2>
                <ul>
                <li>
                    <Link to="/quick-donation">
                      {text.quickDonation}
                    </Link>
                  </li>
                  <li>
                    <Link to="/in-kind-donation">
                      {text.inKindDonation}
                    </Link>
                  </li>
                  <li>
                    <Link to="/our-projects">
                      {text.projects}
                    </Link>
                  </li>
                  <li>
                    <Link to="/critical-cases">
                      {text.criticalCases}
                    </Link>
                  </li>
                  
                </ul>
              </div>
              <div className="footer-links-gold">
                <h2>
                  {text.policy}
                </h2>
                <ul>
                  {policies.map((policy) => (
                    <li key={policy.id || policy.title}>
                      <Link to={getPolicyDetailsPath(policy)}>
                        {policy.title}
                      </Link>
                    </li>
                  ))}
                  <li className="footer-policy-view-all">
                    <Link to="/foundation-policies">
                      {text.viewAll}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="footer-copyright-gold">
              <div className="footer-copyright-text-gold">
                <p>
                  {text.copyright}
                </p>
              </div>
              <div className="footer-social-links-gold">
                <h2>
                  {text.follow}
                </h2>
                <ul>
                  <li>
                    <a href="https://www.facebook.com/tarahumcharity.dubai" target="_blank">
                      <i className="fab fa-facebook"></i>
                      {text.facebook}
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/@tarahumcharity4393" target="_blank">
                      <i className="fab fa-linkedin"></i>
                      {text.youtube}
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/tarahumcharity"  target="_blank">
                      <i className="fab fa-instagram"></i>
                      {text.instagram}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
}
